import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-51060299"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Respuesta", -1))
const _hoisted_4 = {
  key: 0,
  class: "answer"
}
const _hoisted_5 = {
  key: 1,
  style: {"margin-top":"15px"}
}
const _hoisted_6 = ["src"]

import {ref,onMounted,Ref} from 'vue'
  import DefaultLayout from '@/layouts/DefaultLayout.vue';
  import ExercisesService from '@/services/ExerciseService';
  import { useRoute } from 'vue-router';
  import AnswerInterface from '@/interfaces/AnswerInterface';


   
export default /*#__PURE__*/_defineComponent({
  __name: 'AnswerView',
  setup(__props) {

  const loading =ref(false)
   const route = useRoute()
   const service = new ExercisesService()
   const answer:Ref<AnswerInterface> = ref({})

onMounted(async()=>{ 
     loading.value = true;
     answer.value = await service.GetExercisesAnswerDetail(route.params.index)
     loading.value = false;
})


  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", null, "Respuesta del ejercicio " + _toDisplayString(answer.value?.order), 1),
          _hoisted_3,
          (answer.value.answer)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("p", null, _toDisplayString(answer.value?.answer), 1)
              ]))
            : _createCommentVNode("", true),
          (answer.value.answer_image_uri)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, "IMAGEN:"))
            : _createCommentVNode("", true),
          (answer.value.answer_image_uri)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                src: answer.value?.answer_image_uri,
                alt: "IMAGEN DE LA RESPUESTA"
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})